import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const xIntegrationService = {
    getAuthorizeUrl,
    connectIntegration,
    disconnectIntegration,
    connectLocation,
    getAccountInfo,
};

function getAuthorizeUrl() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/x/authorize-url`, requestOptions).then(handleResponse);
}

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/x/connect-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'x' }));
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/x/disconnect-integration${query}`, requestOptions).then(handleResponse);
}

function connectLocation(locationId, integrationId = null) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ locationId, integrationId }),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/x:connect`, requestOptions).then(handleResponse);
}

function getAccountInfo(integrationId = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/x/account-info${query}`, requestOptions).then(handleResponse);
}
